/**
 * internalToolsSelector
 * Selector for the internalToolsSelector state.
 * @param { Object } state: The application state.
 * @returns { Object } The internalToolsSelector state.
 */
export const internalToolsSelector = (state) => state.internalTools;

export const selectProjectLimitData = (state) => internalToolsSelector(state)?.projectLimitData;
